module.exports = __webpack_public_path__ + "static/media/plans-arrow.9fdbcd65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onBoardingArrows/plans-arrow.svg
// module id = 925
// module chunks = 21